import { create } from 'zustand'

interface TabReloadState {
  /** Per-tab-id remount counter. The tab layer keys each tab's content on it,
   *  so bumping a tab's nonce remounts that tab's subtree — resetting all
   *  local editor/card state the way a browser tab reload would. */
  nonces: Record<string, number>
  reload: (tabId: string) => void
}

/**
 * Drives per-tab "reload" without reloading the browser. A tab triggers a
 * remount of its own content by bumping its id's nonce; the tab layer reads
 * the nonce as a React key. Keys are workspace-tab IDS (opaque strings here).
 * Not persisted — purely an in-session remount lever.
 */
export const useTabReload = create<TabReloadState>()((set) => ({
  nonces: {},
  reload: (tabId) =>
    set((s) => ({
      nonces: { ...s.nonces, [tabId]: (s.nonces[tabId] ?? 0) + 1 },
    })),
}))
